import React, { useMemo } from 'react';

/**
 * Sandboxed HTML preview frame (email bodies, template previews).
 *
 * Stored template HTML must never run script in the operator's session,
 * so it renders inside a fully-sandboxed iframe. The HTML is passed via
 * a data: URL instead of srcDoc: sandboxed srcdoc iframes render BLANK
 * inside iOS WKWebView (the mobile app's embedded pages, found
 * 2026-08-11), while data: URLs render everywhere. sandbox="" still
 * blocks scripts/forms/popups either way.
 */
const SandboxedHtmlFrame = ({ html, title = 'Preview', className = '' }) => {
  const src = useMemo(
    () => `data:text/html;charset=utf-8,${encodeURIComponent(html || '')}`,
    [html],
  );
  return <iframe title={title} sandbox="" src={src} className={className} />;
};

export default SandboxedHtmlFrame;
